import React from 'react';

import RenderTextField, { RenderTextFieldProps } from 'shared/forms/render-text-field';

import { useStyles } from './styles';

export type DisabledVariant = 'default' | 'grey';

export type InputFieldProps = RenderTextFieldProps & {
  disabledVariant?: DisabledVariant;
  bordered?: boolean;
};

export const InputField: React.FC<InputFieldProps> = ({
  InputProps,
  label,
  name,
  disabledVariant = 'default',
  bordered = true,
  customLabel,
  ...props
}) => {
  const classes = useStyles({ disabledVariant, bordered });

  return (
    <RenderTextField
      {...props}
      variant="standard"
      name={name}
      InputProps={{
        ...InputProps,
        classes: { input: classes.input, disabled: classes.disabled, underline: classes.underline },
      }}
      customLabel={
        customLabel ?? (
          <label htmlFor={name} className={classes.label}>
            {label}
          </label>
        )
      }
    />
  );
};
